import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, ArrowUpRight } from "lucide-react";

const FaqAccordion = ({ items, dark = false, idPrefix = "faq" }) => {
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <div className="flex flex-col gap-4">
      {items.map((f, i) => {
        const open = openIdx === i;
        return (
          <div
            key={f.q}
            data-testid={`${idPrefix}-item-${i}`}
            className={`rounded-2xl border transition-colors duration-300 ${
              dark
                ? `bg-navy-light border-white/10 ${open ? "border-electric/40" : "hover:border-white/25"}`
                : `bg-white border-navy/10 ${open ? "border-brand/40" : "hover:border-brand/30"}`
            }`}
          >
            <button
              onClick={() => setOpenIdx(open ? null : i)}
              aria-expanded={open}
              aria-controls={`${idPrefix}-panel-${i}`}
              data-testid={`${idPrefix}-question-${i}`}
              className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
            >
              <span className={`font-display font-bold tracking-tight text-base md:text-lg ${dark ? "text-mist" : "text-navy"}`}>
                {f.q}
              </span>
              <span
                className={`shrink-0 w-8 h-8 rounded-full border flex items-center justify-center transition-[transform,border-color,color] duration-300 ${
                  open
                    ? "rotate-45 border-electric text-electric"
                    : dark
                    ? "border-white/15 text-mist/50"
                    : "border-navy/15 text-navy/50"
                }`}
                aria-hidden="true"
              >
                <Plus size={16} />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {open && (
                <motion.div
                  id={`${idPrefix}-panel-${i}`}
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className={`px-6 pb-6 leading-relaxed text-sm md:text-base ${dark ? "text-slatec" : "text-navy/70"}`}>
                    {f.a}
                    {f.link && (
                      <>
                        {" "}
                        <Link
                          to={f.link.to}
                          data-testid={`${idPrefix}-link-${i}`}
                          className={`inline-flex items-center gap-1 font-semibold whitespace-nowrap ${dark ? "text-electric" : "text-brand"} hover:underline`}
                        >
                          {f.link.label}
                          <ArrowUpRight size={14} />
                        </Link>
                      </>
                    )}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};

export default FaqAccordion;
